module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "err"
  }, [_c('v-svg', {
    attrs: {
      "data": '#icon-err'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06aba7e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404/404.vue
// module id = 151
// module chunks = 1